import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Container, TabContent } from 'reactstrap';
import { useParams, useHistory } from "react-router-dom";
import { GolbalDataContext } from '../../components/store/global-data-provider';
import StepWorkflow from "../../components/common/step-workflow";
import RequestUserInformation from '../../components/request/request_user_information';
import ConfigData from '../../config.json';
import axios from 'axios';

const CreateRequest = () => {
  const { tablename } = useParams();
  const history = useHistory();
  const { changeTitlePage } = useContext(GolbalDataContext);
  const [formTemp, setFormTemp] = useState({});

  useEffect(() => {
    changeTitlePage('Create Request');
    let strTableName = "";
    try{
        strTableName = atob(tablename);
    }catch(error){
        strTableName = ""
    }
    if (strTableName === "") {
      history.push("/create-requests");
    }
    LoadFormTemp(strTableName);
  }, []);

  const LoadFormTemp = (strTableName) => {
    let url = ConfigData.API_URL + "form-temp/search-form-temp-table-name?table_name=" + strTableName + "&status=1";
    let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){                
                setFormTemp(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl={12}>
              <div>
                <StepWorkflow step={1} />
                <RequestUserInformation dataFormType={formTemp} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateRequest;